var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-facebook"};

module.exports = Facebook;

Facebook.default = Facebook;
